"use strict";

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es7.object.entries");

exports.__esModule = true;
exports.hasEntries = hasEntries;

function hasEntries(object) {
  if (!object) return false;
  return Object.entries(object).length > 0;
}